import React from 'react';
import { cn } from '../lib/cn';

/**
 * PageHeader — Cabecera de pantalla con título + descripción + acciones.
 */
export const PageHeader = ({ title, description, actions, className }) => (
    <div className={cn('flex items-start justify-between gap-4 mb-5', className)}>
        <div className="min-w-0">
            <h1 className="text-xl font-semibold text-slate-900 leading-tight">{title}</h1>
            {description && (
                <p className="text-sm text-slate-500 mt-1">{description}</p>
            )}
        </div>
        {actions && (
            <div className="flex items-center gap-2 shrink-0">
                {actions}
            </div>
        )}
    </div>
);
